<template>
	<div class="container__filtrografico">
		<InputSearch
			v-model="textFilter"
			style="margin-bottom: 1rem"
			:placeholder="$t('search') + '...'"
		/>
		<div
			v-for="(dadosIndividual, index) in dadosFiltradosPeloCampoDePesquisa"
			:key="index"
			class="container__filtrografico__item"
			@click="checkValue(dadosIndividual)"
		>
			<FiltroGraficoFazendaItem
				:color="dadosIndividual.color"
				:label="dadosIndividual.label"
				:valor="dadosIndividual[propriedadeSelecionada]"
				:is-checked="dadosIndividual.isChecked"
				:max-progress-value="valorMaximoBarraDeProgresso"
				:propriedade-selecionada="propriedadeSelecionada"
			/>
		</div>
	</div>
</template>

<script>
import FiltroGraficoFazendaItem from './FiltroGraficoFazendaItem'
import InputSearch from '../../../../../../components/InputSearch/InputSearch'

import _ from 'lodash'

export default {
	components: { FiltroGraficoFazendaItem, InputSearch },
	props: {
		/**
		 * Dados Necessarios para o filtro
		 */
		dadosDoFiltro: Array,
		/**
		 * Propriedade que deve ser selecionada para mostrar como valor
		 * do progresso
		 */
		propriedadeSelecionada: String,
	},
	data: () => {
		return {
			/**
			 * Campo de pesquisa
			 */
			textFilter: '',
		}
	},
	computed: {
		/**
		 * Dados que foram filtrados pelo campo de pesquisa, ordenado do maior para o menor
		 */
		dadosFiltradosPeloCampoDePesquisa() {
			const dadosFiltrados = this.dadosDoFiltro.filter((f) =>
				f.label.toLowerCase().includes(this.textFilter.toLowerCase()),
			)

			return _.orderBy(dadosFiltrados, [this.propriedadeSelecionada], ['desc'])
		},
		/**
		 * Retorna todos os valores da propriedade que esta selecionada
		 */
		todosOsValoresDaPropriedadeSelecionada() {
			return this.dadosDoFiltro.map((m) => parseFloat(m[this.propriedadeSelecionada]))
		},
		/**
		 * Valor maximo do progresso
		 */
		valorMaximoBarraDeProgresso() {
			if (this.todosOsValoresDaPropriedadeSelecionada) {
				return Math.max(...this.todosOsValoresDaPropriedadeSelecionada) + 20
			}
			return 0
		},
	},
	methods: {
		/**
		 * Faz o check do valor para o objeto
		 */
		checkValue(individualValue) {
			individualValue.isChecked = !individualValue.isChecked
			this.$emit('filterClick', individualValue)
		},
	},
}
</script>

<style scoped>
.container__filtrografico {
	width: 100%;
	height: 100%;
	padding: 1.25rem;
	border: 1px solid rgba(var(--color-rgb-gray), 0.3);
	border-radius: 3px;
	overflow-y: auto;
}

.container__filtrografico__item {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-bottom: 1rem;
	font-size: 0.75rem;
	cursor: pointer;
	color: rgb(var(--color-rgb-gray));
}
</style>
